<template>
  <div class="popular-menu">
    <active-button
      line-color="blue"
      :active="!$route.params.sport"
      :title="$t('common.all-sports')"
      @click="$router.push('/popular')"
    >
      <sport-icon name="all"></sport-icon>
    </active-button>
    <active-button
      v-for="sport in sports"
      :key="sport.id"
      line-color="blue"
      :active="$route.params.sport == sport.id"
      :title="sport.name"
      @click="$router.push(`/popular/sport/${sport.id}`)"
    >
      <sport-icon :name="sport.alias"></sport-icon>
    </active-button>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import SportIcon from '@/components/icons/SportIcon'
import { mapState } from 'vuex'

export default {
  components: {
    ActiveButton,
    SportIcon
  },
  computed: {
    ...mapState({
      sports: state => state.prematch.popular.menu
    })
  }
}
</script>

<style scoped>
.popular-menu { display: flex; }
.active-button { height: 40px; padding: 12px; width: 40px; }
</style>



// WEBPACK FOOTER //
// src/components/sports/main/popular/Menu.vue